// base url
if (location.hostname == 'dev.spleen-creation.be' || location.hostname == 'localhost') {
	var path = '/vscode/';
} else {
	var path = '/';
}

var token = $('html').attr('token');

$(document).ready(function() {
	

	if($('.tinymce').length > 0) {
		// init tinyMCE
		var hash = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		var target = hash[0].split('=');
		var section = target[1].substring(0, 4);

		tinymce.init({
			selector: '.tinymce',
			plugins: "autoresize link image media lists advlist code help paste table",
			paste_as_text: true,
			autoresize_bottom_margin: 20,
			branding: false,
			menubar:false,
			statusbar: false,
			toolbar: "undo redo | formatselect | bold italic underline forecolor fontsizeselect | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat | link media image | code | help",
			image_title: true,
			automatic_uploads: true,
			file_picker_types: 'image',
			file_picker_callback: function (cb, value, meta) {
				var input = document.createElement('input');
				input.setAttribute('type', 'file');
				input.setAttribute('accept', 'image/*');
				input.setAttribute('name', 'img_cont');

				input.onchange = function () {

					$('.tox-dialog').prepend('<div id="loader"><div id="spinner"></div></div>');

					var file = this.files[0];

					var reader = new FileReader();
					reader.onload = function () {

						var id = 'blobid' + (new Date()).getTime();
						var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
						var base64 = reader.result.split(',')[1];
						var blobInfo = blobCache.create(id, file, base64);
						blobCache.add(blobInfo);

						var file_input = $(input).prop('files')[0];
						var formData = new FormData();
						formData.append('file', file_input);
						formData.append('section', section);

						$.ajax({
							url: 'filebrowser.php',
							dataType: 'json',  
							cache: false,
							contentType: false,
							processData: false,
							data: formData,                         
							type: 'post',
							success: function(response){

								$('.tox-dialog #loader').hide();
								
								if (response.action == "bad_ext"){
									toastr.error("Invalid extension file (accept .jpg, .jpeg, .png, .gif)");
								}
								else if (response.action == "copy_failed") {
									toastr.error("The pictures could not be copied");
								}
								else if (response.action == "success") {

									cb(response.img_path, { 
										alt: file.name,
										title: file.name
									});

								}
							}
						});

					};
					reader.readAsDataURL(file);
				};
				input.click();
			}
		});
	}

	// init toastr
	toastr.options = {
		"closeButton": true,
		"debug": false,
		"newestOnTop": false,
		"progressBar": false,
		"positionClass": "toastr-top-right",
		"preventDuplicates": true,
		"onclick": null,
		"showDuration": "300",
		"hideDuration": "1000",
		"timeOut": "2000",
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	}

	// ini flatpicker
	$(".datepicker").flatpickr({
		locale: {
			format: 'DD/MM/YYYY',
    		firstDay: 1
    	}
	});	

	// init Date range picker
	$(".rangepicker").daterangepicker({
		autoApply: true,
		locale: {
			format: 'DD/MM/YYYY',
    		firstDay: 1
    	}
	});

	// ini max length counter
	$('.counter').maxlength({
	    warningClass: "badge badge-success",
	    limitReachedClass: "badge badge-danger"
	});

	// init datatable
	/*if($('body').find('.data-table').length>0) {
		//var language = $('html').attr('lang');
		$('.data-table').DataTable({
			responsive: true,
			fixedHeader: {
				header: false,
				footer: true
			},
           "pageLength": 25,
           "aaSorting": []
      });

		$.fn.dataTable.moment = function ( format, locale ) {
			var types = $.fn.dataTable.ext.type;
			
		    // Add type detection
		    types.detect.unshift( function ( d ) {
		    	return moment( d, format, locale, true ).isValid() ?
		    	'moment-'+format :
		    	null;
		    } );
		    
		    // Add sorting method - use an integer for the sorting
		    types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
		    	return moment( d, format, locale, true ).unix();
		    };
		};

		$.fn.dataTable.moment( 'DD-MM-YYYY' );
	}





	function table_order(path, folder) {
		if($('body').find('.data-table-'+folder+'-order').length>0) {
	        var table = $('.data-table-'+folder+'-order').DataTable({
	            rowReorder: true,
	            "pageLength": 25
	        });

	        table.on( 'row-reorder', function ( e, diff, edit ) {

		        var order_arr = new Array;	

		        $('.data-table-'+folder+'-order tbody tr').each(function() {
		        	order_arr.push($(this).data('id'));
		        });

		        $.post(path+'administration/request/xhr/'+folder+'/order.php', {order_arr: order_arr, token: token}, function(response) {
		        }, 'json');
		    } );
		}
	}*/

	// personnalise les datas à transmettre en dehors d'un serializeArray() dans la fonction xhr_send()
	function xhr_data(file = null, data) {
		switch(file) {
			/*case 'folder/file' (data-xhr):
				
		    	break;*/
		    default:
		    	return true;
	    }
	}

	// personnalise les callback en cas de succès dans la fonction xhr_send()
	function xhr_success(callback = null, response, data) {
		switch(callback) {
			case 'settings/update-keys':
				var dataObj = {};
				for (i = 0; i < data.length; i++) {
					dataObj[data[i].name] = data[i].value;
				}

				if(dataObj['id'] != '') {
					$('tr[data-id='+dataObj['id']+'] .dev').html(dataObj['dev']);
					$('tr[data-id='+dataObj['id']+'] .prod').html(dataObj['prod']);
					if(dataObj['public'] == 1) {
						$('tr[data-id='+dataObj['id']+'] .public').html('<i class="fa fa-check text-success"></i>');
					}
					else {
						$('tr[data-id='+dataObj['id']+'] .public').html('<i class="fa fa-times text-danger"></i>');
					}
				}
				else {
					setTimeout(function() {
						location.reload();
					}, 3000);
				}
				toastr.success(response.msg);
				$('#modal-keys').modal('hide');
		    	break;
			default:
				return true;
		}

	}

	// fonction principale pour l'envoie et le controle de requêtes ajax
	function xhr_send(path, token, $this) {
		var file = $this.data('xhr');
		if($this.data('type') !== undefined) {
			var type = $this.data('type');
		}
		else {
			var type = null;
		}
		var form = '#'+$this.closest('form').attr('id');

		if(type == 'delete') {
			var id = $this.closest('[data-id]').data('id');

			if(confirm('Voulez-vous supprimer cette ligne ?')) {
				$.post(path+'administration/request/xhr/'+file+'.php', { id: id, token: token }, function(response, statusText, jqXHR) {
					if(response.action == 'success') {

						if(response.callback === true) {
							xhr_success(file, response, data);
						}
						else {
							if(response.msg != null) {
								toastr.success(response.msg);
							}
							$this.closest('[data-id]').remove()					
						}

						if(response.url != null) {
							if(response.msg != null) {								
								setTimeout(function() {
									location.href = response.url;
								}, 3000);
							}
							else {
								location.href = response.url;
							}
						}
					}
					else if(response.action == 'empty') {
						if(response.msg != null) {
							toastr.warning(response.msg);
						}
					}
					else if(response.action == 'token') {
						location.reload();
					}   
					else {
						if(response.msg != null) {
							toastr.error(response.msg);
						}
						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', debug:true, token: token}, function(response2) {}, 'json');
					}
				}, 'json')
				.always(function(jqXHR) {
				    if(jqXHR.status == 404) {
						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
				    }
				    else if(jqXHR.status == 500) {			    	
						toastr.error('Request error. Please contact the support');

						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', token: token}, function(response2) {}, 'json');
				    }
				});
			}
		}
		else {
			var data = $(form).serializeArray();
			data[data.length] = { name: 'token', value: token };

			$('.tinymce').each(function() {
				var currentEditorId = $(this).attr('id');
				var val = tinyMCE.get($(this).attr('id')).getContent();

				for (index = 0; index < data.length; ++index) {
				    if (data[index].name == currentEditorId) {
				        data[index].value = val;
				    }
				}
			});

			xhr_data(file, data);

			$('.is-invalid').removeClass('is-invalid');
			$.post(path+'administration/request/xhr/'+file+'.php', data, function(response, statusText, jqXHR) {
				if(response.action == 'success') {
					if(response.callback === true) {
						xhr_success(file, response, data);
					}
					else {
						if(response.msg != null) {
							toastr.success(response.msg);						
						}
					}

					if(response.url != null) {
						if(response.msg != null) {								
							setTimeout(function() {
								location.href = response.url;
							}, 2000);
						}
						else {
							location.href = response.url;
						}
					}
				}
				else if(response.action == 'empty') {
					if(response.msg != null) {
						toastr.warning(response.msg);
					}

					$.each(response.fields, function(i, item) {
					    $(form).find('#'+item).addClass('is-invalid');
					});
				}
				else if(response.action == 'token') {
					location.reload();
				}
				else {
					if(response.msg != null) {
						toastr.error(response.msg);
					}

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', debug:true, token: token}, function(response2) {}, 'json');
				}
			}, 'json')
			.always(function(jqXHR) {
			    if(jqXHR.status == 404) {
					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
			    }
			    else if(jqXHR.status == 500) {			    	
					toastr.error('Request error. Please contact the support');

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', token: token}, function(response2) {}, 'json');
			    }
			});
		}
	}

	// bind un click sur les éléments portant le [data-xhr]
	$(document).on('click', '[data-xhr]', function(e) {
		e.preventDefault();
		var $this = $(this);

		xhr_send(path, token, $this);
	});

	$('.delete').click(function(e){
		if (confirm('Voulez-vous vraiment supprimer ceci?')) {
			$(this).next('form').submit();
		}
		e.preventDefault();
	});

    // ajout et construction d'une section
    $(document).on('click', '.line', function() {
    	var id = $(this).attr('id').split('_')[1];
    	$.get(path+'administration/template/section/_builder.php', {id: id}, function(response) {
    		$('#section_target').append(response.replace('[rel]', ''));
    		$('#section-modal').modal('toggle');
    		$("html, body").animate({ scrollTop: $(document).height() }, 1000);
    	});    		
    });

    // ajout et construction d'une section
    $(document).on('click', '#section_target section', function() {
    	$('#section_target section').removeClass('active');
    	$(this).addClass('active');
    	$('.section-option').slideDown('fast');

    	// ajuster le checkbox fluid
    	if($(this).find('.control').hasClass('class_fluid')) {
    		$('.section-option').find('#fluid').prop('checked', true);
    	}
    	else {
    		$('.section-option').find('#fluid').prop('checked', false);
    	}

    	$('.section-option').find('#id_class').val($(this).find('.control').attr('rel'));
    });

    $(document).on('click', '.close-section', function () {
    	$('#section_target section').removeClass('active');
    	$(".section-option").slideUp('fast');
    });

    $(document).on('click', '#fluid', function () {
    	if($(this).is(':checked')) {
    		$('section.active .control').addClass('class_fluid');
    	}
    	else {			
    		$('section.active .control').removeClass('class_fluid');
    	}
    });

    $(document).on('change', '#id_class', function () {
    	var val = $(this).val();
    	$('section.active .control').attr('rel', val);
    });

    $(document).on('click', '#editor button', function(e) {  
    	var $this= $(this);  	
    	var type = $(this).data('type');

    	$.get(path+'administration/template/section/control/'+type+'.php', function(response) {
    		$this.closest('#editor').parent().html(response.replace('[content]', ''));
    		if(type == 'text') {
    			tinymce.init({
    				selector: '.tinymce',
    				plugins: "autoresize link lists advlist code",
    				autoresize_bottom_margin: 20,
    				branding: false,
    				menubar:false,
    				statusbar: false,
    				toolbar: "undo redo | formatselect | bold italic underline forecolor fontsizeselect | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat | link media image | code | help"
    			});
    		}
    	});

    	e.preventDefault();
    });

    $(document).on('submit', '#form_image', function(e) {
    	$this = $(this);
    	var formData = new FormData(this);
    	formData.append("type", "img");

    	$.ajax({
    		url: path+"administration/request/content/upload.php",
    		type: "POST",
    		data:  formData, 
    		dataType: 'json',
    		contentType: false,
    		cache: false,
    		processData:false,
    		beforeSend : function()
    		{
			//$("#preview").fadeOut();
			$("#err").fadeOut();
		},
		success: function(response)
		{				

			var filename = response.filename;
			var ext = response.ext;
			var id = response.id;
			$.get(path+'administration/template/section/template/img.php', function(data) {
				$this.find('.preview').html(data.replace('[src]', '../dist/assets/img/upload/cont/'+ filename+'_m.'+ext).replace('[id]', id));

						//'<img src="../files/'+ response.filename+'_m.'+response.ext+'" class="img-fluid" /><input name="img" type="hidden" value="'+response.id+'" />');
					});

				//$this.closest('[data-type]').find('.preview').html('<img src="../files/'+ response.filename+'_m.'+response.ext+'" class="img-fluid" /><input name="img" type="hidden" value="'+response.id+'" />');
			},
			error: function(e) 
			{
				toastr.error(response.msg);
			}          
		});


    	e.preventDefault();
    	return false;
    });

    // ajout d'une image dans le hook depuis la librairie media
    $(document).on('click', '.choose-pic', function(e) {
    	var id = $(this).data('pic');
    	var src = $(this).attr('rel');

    	$(this).closest('[data-type]').find('input[name="img"]').val(id);
    	$(this).closest('[data-type]').find('.preview img').attr('src', src);

    	$('#choose-pic-modal').modal('toggle');
    });

    $('.custom-file-input').on('change', function() {
    	let fileName = $(this).val().split('\\').pop();
    	$(this).siblings('.custom-file-label').addClass('selected').html(fileName);
    });

    $(document).on('submit', '#form_file', function(e) {
    	$this = $(this);

    	$.ajax({
    		url: path+"administration/request/content/upload.php",
    		type: "POST",
    		data:  new FormData(this), 
    		dataType: 'json',
    		contentType: false,
    		cache: false,
    		processData:false,
    		beforeSend : function()
    		{
			//$("#preview").fadeOut();
			$("#err").fadeOut();
		},
		success: function(response)
		{	
			location.reload();
		},
		error: function(e) 
		{
			toastr.error(response.msg);
		}          
	});


    	e.preventDefault();
    	return false;
    });

	// save template et contenu
	$(document).on('click', '#update-content', function(e) {
		var page = $('input[name=page]').val();	
		var lang = $('input[name=lang]').val();
		var menu_title = $('input[name=menu_title]').val();
		var admin_title = $('input[name=admin_title]').val();

		if($("#Online_page").is(':checked')) {
			var show = 1;
		}
		else {
			var show = 0;
		}

		if($("#secure_login").is(':checked')) {
			var secure_login = 1;
		}
		else {
			var secure_login = 0;
		}	

		if($("#secure").is(':checked')) {
			var secure = 1;
		}
		else {
			var secure = 0;
		}	

		if($("#Menu_visible").is(':checked')) {
			var menu = 1;
		}
		else {
			var menu = 0;
		}

		var menu_id = $('#Menu_id').val();	

		var structure = [];
		var content = [];
		var type = [];
		var val = [];
		var hook = [];
		var fluid = [];
		var add_class = [];
		var i = 0;
		
		$('#section_target section').each(function() {
			structure[i] = $(this).attr('id').split('_')[1];

			// gestion class fluid
			if($(this).find('.control').hasClass('class_fluid')) {
				fluid[i] = 1;
			}
			else {
				fluid[i] = 0;
			}

			// ajout de class/id
			if($(this).find('.control').attr('rel') !== undefined) {
				add_class[i] = $(this).find('.control').attr('rel');
			}
			else {
				add_class[i] = 'null';	 		
			}

			console.log(add_class[i]);
			
			var type_section = [];
			var val_section = [];
			var j = 0;
			$('div[data-type]', this).each(function() {
				type_section[j] = $(this).data('type');
				type[i] = type_section;

				if($(this).data('type') == 'code') {
					var $this = $(this);
					var hook_section = [];

					$('div[data-hook]', this).each(function(index) {
						if($(this).data('hook') == 'text') {
							var currentEditorId = $(this).find('.tinymce').attr('id');							
							hook_section.push(tinyMCE.get(currentEditorId).getContent());
						}
						else {
							var val = $(this).find('input[name="img"], input[name="video"]').val();
							hook_section.push(val);
							//hook_section.push($(this).val());
						}
					});

					hook[i] = hook_section;
				}

				if($(this).data('type') == 'text') {
					var currentEditorId = $(this).find('.tinymce').attr('id');
					var val = tinyMCE.get(currentEditorId).getContent();
				}
				else {
					var val = $(this).find('input[type="text"], input[type="search"], input[type="hidden"]').val();
					console.log('hidden'+val);
				}
				val_section[j] = val;
				content[i] = val_section;
				j++;
			});

			i++;
		});
		if( $('#Id_page_content').length > 0 ){
			var Id_page_content = $('#Id_page_content').val();
		} else {
			var Id_page_content = "none";
		}
		$.post(path+'administration/request/content/add_section.php', { 
			page: page, 
			lang: lang, 
			menu_title: menu_title,
			admin_title: admin_title,
			show: show, 
			menu: menu, 
			menu_id: menu_id, 
			type: type, 
			structure: structure, 
			content: content, 
			hook: hook,
			fluid: fluid,
			add_class: add_class,
			secure_login: secure_login,
			secure: secure,
			Id_page_content: Id_page_content,
			token: token
		}, function(response) {
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}			
			else {
				toastr.error(response.msg);
			}
		}, 'json');

		e.preventDefault();
	});

    // save template et contenu
    $(document).on('click', '#save-content', function(e) {
    	var page = $('input[name=page]').val();	
    	var lang = $('input[name=lang]').val();
    	var menu_title = $('input[name=menu_title]').val();
    	var admin_title = $('input[name=admin_title]').val();

    	if($("#Online_page").is(':checked')) {
    		var show = 1;
    	}
    	else {
    		var show = 0;
    	}

    	if($("#secure_login").is(':checked')) {
    		var secure_login = 1;
    	}
    	else {
    		var secure_login = 0;
    	}	

    	if($("#secure").is(':checked')) {
    		var secure = 1;
    	}
    	else {
    		var secure = 0;
    	}	

    	if($("#Menu_visible").is(':checked')) {
    		var menu = 1;
    	}
    	else {
    		var menu = 0;
    	}

    	var menu_id = $('#Menu_id').val();	

    	var structure = [];
    	var content = [];
    	var type = [];
    	var val = [];
    	var hook = [];
    	var fluid = [];
    	var add_class = [];
    	var i = 0;
    	
    	$('#section_target section').each(function() {
    		structure[i] = $(this).attr('id').split('_')[1];

	 		// gestion class fluid
	 		if($(this).find('.control').hasClass('class_fluid')) {
	 			fluid[i] = 1;
	 		}
	 		else {
	 			fluid[i] = 0;
	 		}

	 		// ajout de class/id
	 		if($(this).find('.control').attr('rel') !== undefined) {
	 			add_class[i] = $(this).find('.control').attr('rel');
	 		}
	 		else {
	 			add_class[i] = 'null';	 		
	 		}

	 		console.log(add_class[i]);
	 		
	 		var type_section = [];
	 		var val_section = [];
	 		var j = 0;
	 		$('div[data-type]', this).each(function() {
	 			type_section[j] = $(this).data('type');
	 			type[i] = type_section;

	 			if($(this).data('type') == 'code') {
	 				var $this = $(this);
	 				var hook_section = [];

	 				$('div[data-hook]', this).each(function(index) {
	 					if($(this).data('hook') == 'text') {
	 						var currentEditorId = $(this).find('.tinymce').attr('id');							
	 						hook_section.push(tinyMCE.get(currentEditorId).getContent());
	 					}
	 					else {
	 						var val = $(this).find('input[name="img"], input[name="video"]').val();
	 						hook_section.push(val);
	 					}
	 				});

	 				hook[i] = hook_section;
	 			}

	 			if($(this).data('type') == 'text') {
	 				var currentEditorId = $(this).find('.tinymce').attr('id');
	 				var val = tinyMCE.get(currentEditorId).getContent();
	 			}
	 			else {
	 				var val = $(this).find('input[type="text"], input[type="hidden"]').val();
	 				console.log(val);
	 			}
	 			val_section[j] = val;
	 			content[i] = val_section;
	 			j++;
	 		});

	 		i++;
	 	});

    	$.post(path+'administration/request/content/add_section.php', { 
    		page: page, 
    		lang: lang, 
    		menu_title: menu_title,
    		admin_title: admin_title,
    		show: show, 
    		menu: menu, 
    		menu_id: menu_id, 
    		type: type, 
    		structure: structure, 
    		content: content, 
    		hook: hook,
    		fluid: fluid,
    		add_class: add_class,
    		secure_login: secure_login,
    		secure: secure,
    		token: token
    	}, function(response) {
    		if(response.action=='success') {
    			toastr.success(response.msg);
    		}
    		else {
    			toastr.error(response.msg);
    		}
    	}, 'json');

    	e.preventDefault();
    });

	// save template et contenu
	$(document).on('click', '.delete-section', function(e) {
		$(this).closest('section').remove();
		e.preventDefault();
	});


	// ajouter une nouvelle page
	$(document).on('click', '#add-content', function(e) {
		var lang = $('html').attr('lang');
		var data = $('#add-content-form').serializeArray();
		data[data.length] = { name: 'token', value: token };

		$.getJSON(path+'administration/request/content/add_content.php', data, function(response) {

			if(response.action=='success') {
				toastr.success(response.msg);
				document.location.href =  path+'administration/index.php?target=content&lang='+lang+'&process=update&Id_contents='+response.id;
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}            
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});

	$('select[name=reload_version]').change(function() {
		var Id_page_content = $(this).val();
		var lang = $('input[name=Lng]').val();
		$('#previewBackup').html('<a href="/'+lang+'?Id_page_content='+Id_page_content+'&preview" target="_blank" class="float-right"><i class="fas fa-desktop url_content"></i></a>');
		$('#Id_page_content').val(Id_page_content);
		$.post(path+'administration/request/content/reload.php', { 'Id_page_content' : $(this).val(), 'Lng' : $('input[name=Lng]').val() }, function(response) {
			$('#section_target').html(response);
			tinymce.init({
				selector: '.tinymce',
				plugins: "autoresize link lists advlist code help",
				autoresize_bottom_margin: 20,
				branding: false,
				menubar:false,
				statusbar: false,
				toolbar: "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | link code",
				color_map: [
				"555D65", "Black",
				"E2001A", "Red",
				"89D221", "Green",
				"00254D", "Blue",
				"9ABCE1", "LightBlue"
				]
			});
		});
	});

	$(document).on('change', 'input[name=video]', function(e) {
		var $this = $(this);
		var val = $(this).val();
		$.get(path+'administration/template/section/template/video.php', function(response) {
			$this.closest('[data-type]').find('.preview').html(response.replace('[src]', val));
		});
	});

	$(document).on('change', 'input[name=code]', function(e) {
		var $this = $(this);
		var hook = $(this).val();
		$.get(path+'administration/template/section/template/code.php', {hook: hook}, function(response) {
			$this.closest('[data-type]').find('.preview').html(response);

			tinymce.init({
				selector: '.tinymce',
				plugins: "autoresize link lists advlist code",
				autoresize_bottom_margin: 20,
				branding: false,
				menubar:false,
				statusbar: false,
				toolbar: "formatselect | undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | removeformat code help"
			});
		});
	});

	// sortable catégories
	if($('body').find('#section_target section').length>0) {
		$('#section_target').sortable({
			axis: 'y',
			start: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceRemoveEditor', false, $(this).attr('id'));
				});
			},
			stop: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceAddEditor', true, $(this).attr('id'));
				});
			}
		});
	}

	// sortable catégories
	if($('body').find('.preview [data-hook]').length>0) {
		$('.preview').sortable({
			axis: 'y',
			start: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceRemoveEditor', false, $(this).attr('id'));
				});
			},
			stop: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceAddEditor', true, $(this).attr('id'));
				});
			}
		});
	}


	// mettre une page en ligne ou hors ligne
	$(document).on('click', '#sync-page', function(e) {
		var id = $(this).data('id');
		var lang = $(this).data('lang');
		$.getJSON(path+'administration/request/content/sync-page.php', {id: id, lang: lang, token: token }, function(response) {

			if(response.action=='success') {
				toastr.success(response.msg);
				location.reload();
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});	

	$(document).on('click', '.add-keyword', function(e) {
		$('#form-save-keyword input[type="text"]').val('');
		$('#form-save-keyword #id_keyword').attr('readonly', false).removeClass('form-control-solid');
		$('#modal-keyword').modal('show'); 
		e.preventDefault();
	});

	$(document).on('keydown keyup change', '.uppercaser', function(e) {
		$(this).val($(this).val().toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\p{Diacritic}/gu, "").replace(/\s+/g, "_").replace(/[^\w\s\']|_/g, "_").replace('___', '_').replace('__', '_').replace(/^_+/, ''));
	});

	$(document).on('click', '.update-keyword', function(e) {
		var id = $(this).data('id');

		$.getJSON(path+'administration/request/keyword/get-keyword.php', {id:id, token: token }, function(response) {
			if(response.action == 'success') {
				$('#form-save-keyword input[type="text"]').val('');
				$('#form-save-keyword #id_keyword').val(id);

				$('#form-save-keyword #id_keyword').attr('readonly', true).addClass('form-control-solid');

				$.each(response.keywords, function(key, value) {
					$('#form-save-keyword input[name="' + key + '"').val(value);
				});

				$('#modal-keyword').modal('show'); 
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}
			else {
				toastr.error(response.msg);
			}
		});
		e.preventDefault();
	});

	// ajout des données de facturation
	$(document).on('click', '#save-keyword', function(e) {	
		var data = $('#form-save-keyword').serializeArray();
		data[data.length] = { name: 'token', value: token };

		$.getJSON(path+'administration/request/keyword/update-keyword.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				$('#modal-keyword').toggle();
				location.reload();
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}			
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	$(document).on('click', '.add-keys', function(e) {
		$('#form-save-keys input').val('');
		$('#form-save-keys #key-name').attr('readonly', false).removeClass('form-control-solid');
		$('#modal-keys').modal('show'); 
		e.preventDefault();
	});


	$(document).on('click', '.update-keys', function(e) {
		var id = $(this).closest('[data-id]').data('id');

		$.getJSON(path+'administration/request/xhr/settings/get-keys.php', {id:id, token: token }, function(response) {
			if(response.action == 'success') {
				$('#form-save-keys input[type="text"]').val('');
				$('#form-save-keys #id').val(id);

				$('#form-save-keys #key-name').attr('readonly', true).addClass('form-control-solid');
				$('#form-save-keys #key-name').val(response.keys.name);
				$('#form-save-keys #dev').val(response.keys.dev);
				$('#form-save-keys #prod').val(response.keys.prod);
				if(response.keys.public == 1) {					
					$('#form-save-keys #public').prop('checked', true);
				}
				else {
					$('#form-save-keys #public').prop('checked', false);
				}
				

				$('#modal-keys').modal('show'); 
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}
			else {
				toastr.error(response.msg);
			}
		});
		e.preventDefault();
	});

	$(document).on('submit', '#update-meta-form', function(e) {
		var lang = $('html').attr('lang');
		var data = $(this).serializeArray();
		data[data.length] = { name: 'token', value: token };

		$.getJSON(path+'administration/request/content/meta.php', data, function(response) {

			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});

	$(document).on('click','.log-show', function(e){
		var id = $(this).data('id');

		$.getJSON(path+'administration/request/xhr/logs/get-logs.php', {id:id}, function(response){
			if (response.action == 'success') {
				$('#modal_log').modal('show');
				$('#modal_log .modal-title').html(response.title);
				$('#modal_log .modal-body').html(response.html);
			}
		});
	});

	$(document).on('click','[data-settings-users]', function(e){
		var id = $(this).closest('[data-id]').data('id');
		var type = $(this).data('settings-users');

		var access;
		if($(this).is(':checked')) {
			access = 1;
		}
		else {
			access = 0;
		}

		$.post(path+'administration/request/xhr/settings/update-access.php', {id:id, access: access, type: type, token: token}, function(response){
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		}, 'json');
	});

	$(document).on('click','[data-settings-modules]', function(e){
		var id = $(this).closest('[data-id]').data('id');

		var access;
		if($(this).is(':checked')) {
			access = 1;
		}
		else {
			access = 0;
		}

		$.post(path+'administration/request/xhr/settings/update-module.php', {id:id, access: access, token: token}, function(response){
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		}, 'json');
	});



	$(document).on('click','[data-settings-languages]', function(e){
		var id = $(this).closest('[data-id]').data('id');

		var access;
		if($(this).is(':checked')) {
			access = 1;
		}
		else {
			access = 0;
		}

		$.post(path+'administration/request/xhr/settings/update-language.php', {id:id, access: access, token: token}, function(response){
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		}, 'json');
	});

	$(document).on('click','.get-logs-errors', function(e){
		e.preventDefault();

		var id = $(this).closest('[data-id]').data('id');

		$.getJSON(path+'administration/request/xhr/settings/get-logs-errors.php', {id:id, token: token}, function(response){
			if (response.action == 'success') {
				$('#modal-logs-errors').modal('show');
				$('#modal-logs-errors .modal-title').html(response.title);
				$('#modal-logs-errors .modal-body').html(response.html);
			}
		});
	});

	 
});

	

"use strict";

// Class definition
if($('.data-table').length > 0) {
	var KTDatatablesButtons = function () {
	    // Shared variables
	    var table;
	    var datatable;

	    // Private functions
	    var initDatatable = function () {
	        // Set date data order
	        const tableRows = table.querySelectorAll('tbody tr');

	        tableRows.forEach(row => {
	            const dateRow = row.querySelectorAll('td');
	        });

	        // Init datatable --- more info on datatables: https://datatables.net/manual/
	        datatable = $(table).DataTable({
	            "info": false,
	            'order': [],
	            'pageLength': 50,
	            ordering: true,
	           "aaSorting": [],

	            rowReorder: true,
	        });

	        datatable.on( 'row-reorder', function ( e, diff, edit ) {

		        var order_arr = new Array;
		        var order_db = $('.table-order').data('table-order');

		        $('.table-order tbody tr').each(function() {
		        	order_arr.push($(this).data('id'));
		        });

		        $.post('../administration/request/xhr/'+order_db+'/order.php', {order_arr: order_arr, token: token}, function(response) {
		        	location.reload();
		        }, 'json');
		    });
	    }

	    // Hook export buttons
	    var exportButtons = () => {
	        const documentTitle = 'Customer Orders Report';
	        var buttons = new $.fn.dataTable.Buttons(table, {
	            buttons: [
	                {
	                    extend: 'copyHtml5',
	                    title: documentTitle
	                },
	                {
	                    extend: 'excelHtml5',
	                    title: documentTitle
	                },
	                {
	                    extend: 'csvHtml5',
	                    title: documentTitle
	                },
	                {
	                    extend: 'pdfHtml5',
	                    title: documentTitle
	                }
	            ]
	        }).container().appendTo($('#datatable-export'));

	        // Hook dropdown menu click event to datatable export buttons
	        const exportButtons = document.querySelectorAll('#datatable-export-menu [data-kt-export]');
	        exportButtons.forEach(exportButton => {
	            exportButton.addEventListener('click', e => {
	                e.preventDefault();

	                // Get clicked export value
	                const exportValue = e.target.getAttribute('data-kt-export');
	                const target = document.querySelector('.dt-buttons .buttons-' + exportValue);

	                // Trigger click event on hidden datatable export buttons
	                target.click();
	            });
	        });
	    }

	    // Search Datatable --- official docs reference: https://datatables.net/reference/api/search()
	    var handleSearchDatatable = () => {
	        const filterSearch = document.querySelector('[data-kt-filter="search"]');
	        filterSearch.addEventListener('keyup', function (e) {
	            datatable.search(e.target.value).draw();
	        });
	    }

	    // Public methods
	    return {
	        init: function () {
	            table = document.querySelector('.data-table');

	            if ( !table ) {
	                return;
	            }

	            initDatatable();
	            exportButtons();
	            handleSearchDatatable();
	        }
	    };
	}();

	// On document ready
	KTUtil.onDOMContentLoaded(function () {
	    KTDatatablesButtons.init();
	});
}







if($('#kt_dropzonejs_image').length > 0) {
	// set the dropzone container id
	const id = "#kt_dropzonejs_image";
	const dropzone = document.querySelector(id);

	// set the preview element template
	var previewNode = dropzone.querySelector(".dropzone-item");
	previewNode.id = "";
	var previewTemplate = previewNode.parentNode.innerHTML;
	previewNode.parentNode.removeChild(previewNode);


	var folder = $("#kt_dropzonejs_image").data('folder');
	var record = $("#kt_dropzonejs_image").data('record');
	var input = $("#kt_dropzonejs_image").data('input');


	var myDropzone = new Dropzone(id, { // Make the whole body a dropzone
	    url: path+'administration/request/xhr/upload/upload.php?folder='+folder+'&record='+record+'&input='+input, // Set the url for your upload script location
	    acceptedFiles: 'image/*',
	    parallelUploads: 20,
	    maxFilesize: 8, // Max filesize in MB
	    previewTemplate: previewTemplate,
	    previewsContainer: id + " .dropzone-items", // Define the container to display the previews
	    clickable: id + " .dropzone-select" // Define the element that should be used as click trigger to select files.
	});

	myDropzone.on("addedfile", function (file) {
	    // Hookup the start button
	    const dropzoneItems = dropzone.querySelectorAll('.dropzone-item');
	    dropzoneItems.forEach(dropzoneItem => {
	        dropzoneItem.style.display = '';
	    });
	});

	// Update the total progress bar
	myDropzone.on("totaluploadprogress", function (progress) {
	    const progressBars = dropzone.querySelectorAll('.progress-bar');
	    progressBars.forEach(progressBar => {
	        progressBar.style.width = progress + "%";
	    });
	});

	myDropzone.on("sending", function (file) {
	    // Show the total progress bar when upload starts
	    const progressBars = dropzone.querySelectorAll('.progress-bar');
	    progressBars.forEach(progressBar => {
	        progressBar.style.opacity = "1";
	    });
	});

	// Hide the total progress bar when nothing"s uploading anymore
	myDropzone.on("complete", function (progress) {
	    const progressBars = dropzone.querySelectorAll('.dz-complete');

	    setTimeout(function () {
	        progressBars.forEach(progressBar => {
	            progressBar.querySelector('.progress-bar').style.opacity = "0";
	            progressBar.querySelector('.progress').style.opacity = "0";
	        });
	    }, 300);
	    console.log(progress);

	    if(progress.status == 'success') {    	
		    toastr.success('File uploaded')
		    setTimeout(function () {
		        location.reload();
		    }, 3000);
	    }
	    
	});
}



